import { createFileRoute } from "@tanstack/react-router";
import { PortalUsagePage } from "@/features/portal-usage/page";
import { portalUsageSearchSchema } from "@/features/portal-usage/search";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute("/_auth/konfiguracja/statystyki-uzycia")({
	validateSearch: (search) => portalUsageSearchSchema.parse(search),
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.system.statystyki-uzycia",
			location.pathname,
		);
	},
	component: PortalUsagePage,
});
